export const knownUnits = {
  SHT: 'SHT', // sheet
  PCS: 'PCS', // pieces
  KG: 'KG', // kilogram
  M: 'M', // meter
  MM: 'MM', // millimeter
  WholeUnits: ['PCS', 'SHT', 'MM', 'h', 'min']
};

export enum knownUnitsEnum {
  SHT = 'SHT', // sheet
  PCS = 'PCS', // pieces
  KG = 'KG', // kilogram
  M = 'M', // meter
  MM = 'MM', // millimeter
}
